<template>
  <chatbot-modal>
    <div slot="header" class="modal_header">
<!--      <div class="modal_imgWrap" @click.prevent="SET_CHAT(false)">-->
<!--        <img src="@/assets/images/back.svg">-->
<!--      </div>-->
        <div class="header_txt">
          <img src="@/assets/images/chat_logo.svg">
          <p>보통 수십 분 내에 응답합니다.</p>
        </div>
      <div class="modal_closeBtn" @click.prevent="SET_CHAT(false)">
        <img src="@/assets/images/x_white.svg">
      </div>
    </div>
    <div slot="body">
      <div class="chat_date">
        <p id="date"></p>
      </div>
      <div class="chat_wrap">
        <div class="response">
          <div class="cw_header">
            <span class="cw_logo">
              <img src="@/assets/images/chat_cn.svg">
            </span>
            <div class="cw_title">
              <p>땡큐이비인후과</p>
              <p class="time" id="time"></p>
            </div>
          </div>
          <div class="cw_space">
            <div class="space_content">
              <p>안녕하세요</p>
              <p>땡큐 이비인후과 입니다!</p>
              <br>
              <p>간단한 문의는 아래 서포트 봇으로 보다 쉽고 빠르게 답변을 </p>
              <p>확인하실 수 있습니다.</p>
              <br>
              <!-- <p>병원 운영시간</p>
              <p>월~금: 오전 10시~오후 7시</p> -->
            </div>
          </div>
        </div>
        <div class="format">
          <beat-loader :loading="loader.loading" :color="loader.color" :size="loader.size"></beat-loader>
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="errorWrap" v-if="errorFlag">
        <span>메시지를 전송하지 못했습니다.</span>
      </div>
      <div class="send_wrap">
        <form @submit.prevent="init()">
          <textarea type="text" placeholder="메시지를 입력해주세요." v-model="queryString" ref="queryString"></textarea>
          <div class="sw_imgWrap">
            <button type="submit" :disabled="!inputError">
              <img :src="inputError ? require(`@/assets/images/${imgOn}`) : require(`@/assets/images/${imgUn}`)">
            </button>
          </div>
        </form>
      </div>
    </div>
  </chatbot-modal>
</template>

<script>
import BeatLoader from 'vue-spinner/src/BeatLoader'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import ChatbotModal from './ChatbotModal.vue'

export default {
  props: {
  },
  components: {
    BeatLoader,
    ChatbotModal
  },
  data () {
    return {
      loader: {
        loading: false,
        color: '#ff6565',
        size: '15px'
      },
      queryString: '',
      inputError: false,
      imgOn: 'send.png',
      imgUn: 'send-disabled.png',
      errorFlag: false,
      setCount: false
    }
  },
  mounted () {
    const date = document.getElementById('date')
    const time = document.getElementById('time')
    const today = new Date()
    const dateFormat = this.$moment(today).format('YYYY-MM-DD')
    const timeFormat = this.$moment(today).format('LT')
    date.innerText = dateFormat
    time.innerText = timeFormat
    this.$refs.queryString.focus()
  },
  watch: {
    queryString (val) {
      this.inputError = !!val.trim().length
    }
  },
  computed: {
    ...mapGetters('chatbot', [
      'getChat'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_CHAT'
    ]),
    ...mapActions('chatbot', [
      'CHAT_BOT'
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    init () {
      const msg = this.queryString
      console.log('msg: ', msg)
      this.creatMsgTag(msg)
    },
    creatMsgTag (msg) {
      const format = document.querySelector('.format')
      const request = document.createElement('div')
      request.classList.add('request')
      format.appendChild(request)
      let requestTime = new Date()
      requestTime = this.$moment(requestTime).format('LT')
      const appendHtml =
        '<div class="cw_header">' +
          '<div class="cw_title">' +
            `<p class="time">${requestTime}</p>` +
          '</div>' +
        '</div>' +
        '<div class="cw_space">' +
          '<div class="space_content">' +
            `<p>${msg}</p>` +
          '</div>' +
        '</div>'
      request.innerHTML = appendHtml
      /* 스크롤 하단으로 고정 */
      const modalBody = document.querySelector('.modal-body')
      modalBody.scrollTop = modalBody.scrollHeight
      this.loader.loading = true
      this.sendMsg()
    },
    async sendMsg () {
      const data = {
        queryString: this.queryString
      }
      try {
        await this.CHAT_BOT(data)
          .then(() => {
            this.errorFlag = false
            const chat = this.getChat
            const format = document.querySelector('.format')
            const request = document.createElement('div')
            request.classList.add('request')
            const response = document.createElement('div')
            response.classList.add('response')
            format.appendChild(request)
            format.appendChild(response)
            const image = require('@/assets/images/chat_cn.svg')
            let responseTime = new Date()
            responseTime = this.$moment(responseTime).format('LT')
            const appendResponse =
              '<div class="cw_header">' +
                '<span class="cw_logo">' +
                  `<img src=${image}>` +
                '</span>' +
                '<div class="cw_title">' +
                  '<p>땡큐이비인후과</p>' +
                  `<p class="time">${responseTime}</p>` +
                '</div>' +
              '</div>' +
              '<div class="cw_space">' +
                '<div class="space_content">' +
                  `<p>${chat.reply}</p>` +
                '</div>' +
              '</div>'
            response.innerHTML = appendResponse
            /* 스크롤 하단으로 고정 */
            const modalBody = document.querySelector('.modal-body')
            modalBody.scrollTop = modalBody.scrollHeight
          })
      } catch (e) {
        this.errorFlag = true
        console.log('error: ', e)
      } finally {
        this.queryString = ''
        this.$refs.queryString.focus()
        this.loader.loading = false
      }
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>

</style>
